import { initNavAuth } from './auth-ui.js';
import { initNavigation } from './navigation.js';

// Initialize navigation auth when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    console.log('DOM Content Loaded - Initializing Navigation Auth');
    
    // Wait a bit to ensure all elements are loaded
    setTimeout(() => {
        const userAvatarSection = document.getElementById('user-avatar-section');
        
        if (!userAvatarSection) {
            console.error('User avatar section not found in the DOM');
            return;
        }
        
        console.log('User avatar section found, initializing navigation auth');
        initNavAuth();
        initNavigation();
        console.log('Navigation Auth and Navigation highlighting initialized');
    }, 100);
}); 